import { useContext } from 'react';

import { BrandContext } from 'context/BrandContext';
import { isStandardVariant } from 'helpers/iconSizes';
import { ICON_SIZES } from 'lib/constants/iconSizes';

const Lightning = ({ className = '', svgSize = ICON_SIZES.MD }) => {
  const { theme } = useContext(BrandContext);
  const isStandardVariantIcon = isStandardVariant(svgSize);

  if (isStandardVariantIcon) {
    return (
      <svg
        width={svgSize}
        height={svgSize}
        className={className}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.43926 17.9406L18.3334 3L16.4993 11.8649C16.4137 12.2787 16.7296 12.6667 17.1521 12.6667H24.0319C24.5753 12.6667 24.8905 13.2819 24.5729 13.7229L13.3334 29.3333L14.8754 19.7728C14.9408 19.3675 14.6278 19 14.2173 19H7.97793C7.4327 19 7.11802 18.3811 7.43926 17.9406Z"
          fill={theme.icon.fill}
        />
        <path
          d="M17.7944 2.60724C17.9793 2.35376 18.3161 2.26361 18.603 2.39044C18.8899 2.51753 19.0492 2.82732 18.9858 3.13458L17.1519 11.9998H24.0317C25.1185 11.9999 25.7487 13.2302 25.1138 14.1121L13.8745 29.7225C13.6939 29.9733 13.3643 30.0671 13.0786 29.949C12.7933 29.8309 12.6263 29.5323 12.6753 29.2274L14.2173 19.6668H7.97803C6.88794 19.6665 6.25791 18.4287 6.8999 17.5477L17.7944 2.60724ZM7.97803 18.3328H14.2173C15.0382 18.333 15.6643 19.0683 15.5337 19.8787L14.4409 26.6531L24.0317 13.3328H17.1519C16.3071 13.3326 15.675 12.5566 15.8462 11.7293L17.0552 5.88263L7.97803 18.3328Z"
          fill={theme.icon.stroke}
        />
      </svg>
    );
  }

  return (
    <svg
      width={svgSize}
      height={svgSize}
      className={className}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.3725 25.7506L32.0833 5.25L13.0186 31.396C12.4564 32.1669 13.0071 33.25 13.9612 33.25H24.8801C25.5985 33.25 26.1463 33.8931 26.0319 34.6024L23.3333 51.3333L33.6487 29.0739C34.007 28.3007 33.4424 27.4167 32.5902 27.4167H23.4269C22.5704 27.4167 22.0059 26.5246 22.3725 25.7506Z"
        fill={theme.icon.fill}
      />
      <path
        d="M31.3762 4.73486C31.6189 4.40221 32.0612 4.28399 32.4377 4.45068C32.8141 4.61766 33.0231 5.02495 32.9397 5.42822L29.7297 20.9409C29.6927 21.1216 29.8314 21.2922 30.0159 21.2925H42.0549C43.7191 21.2925 44.6845 23.1763 43.7122 24.5269L24.0432 51.8452C23.8061 52.1741 23.373 52.297 22.9983 52.1421C22.624 51.987 22.4049 51.5948 22.469 51.1948L25.1672 34.4634C25.1957 34.2863 25.0595 34.1258 24.8801 34.1255H13.9612C12.2921 34.1251 11.3283 32.2304 12.3108 30.8813L31.3762 4.73486ZM13.7249 31.9116C13.585 32.1042 13.7231 32.3751 13.9612 32.3755H24.8801C26.1372 32.3758 27.0959 33.5016 26.8958 34.7427L24.7854 47.8179L42.2922 23.5044C42.4311 23.3115 42.2927 23.0425 42.0549 23.0425H30.0159C28.7224 23.0422 27.7551 21.8531 28.0168 20.5864L30.4055 9.03564L13.7249 31.9116Z"
        fill={theme.icon.stroke}
      />
    </svg>
  );
};

Lightning.propTypes = {
  className: PropTypes.string,
  svgSize: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default Lightning;
